// extracted by mini-css-extract-plugin
export default {"gridContainer":"procedures_gridContainer__m2uVG","boxShadow":"procedures_boxShadow__fNOB+"};